export default __webpack_public_path__ + "static/10-a54a6f9c917074f2d5807da8fd53fcdd.webp";